import { css } from "@emotion/css";
import { Separator as ReactAriaSeparator } from "react-aria-components";

export function Separator() {
  return <ReactAriaSeparator className={styles.separator} />;
}

const styles = {
  separator: css({
    height: "1px",
    marginBottom: "var(--space-1)",
    marginTop: "var(--space-1)",
    background: "var(--border-base)",
  }),
};
